import React from 'react';
type HighlightProps = {
  children: React.ReactNode;
  className?: string;
};
export function Highlight({
  children,
  className = ''
}: HighlightProps) {
  return <span className={`underline decoration-sun decoration-[0.3em] underline-offset-[-0.1em] [text-decoration-skip-ink:none] ${className}`} data-id="element-138" data-mp="1w42jgiuz4v5">
      {children}
    </span>;
}